import { Box, Stack, useTheme } from "@mui/material";
import FooterLayout from "../../footer/footerLayout";
import NavigationLayout from "../../navigation/navigationLayout";
import DigitalServicesHero from "../digitalServicesHero";
import SolutionsView from "../solutionsView";
import TechStackList from "../techStackList";
import ProjectDetails from "../projectDetails";
import { useTranslation } from "react-i18next";
import projectsData from '../../../assets/data/projects.json';
import { useCallback, useEffect, useState } from "react";
import GetQuote from "../../contactUs/getQuote";
import ButtonComponent from "../../../components/form/buttonComponent";
import companyData from '../../../assets/data/company.json';

const key = "services.ai";

const techStackList = [
    { src: "/images/tech-stack/Python.png", alt: "Python" },
    { src: "/images/tech-stack/R.png", alt: "R" },
    { src: "/images/tech-stack/TensorFlow.png", alt: "TensorFlow" },
    { src: "/images/tech-stack/PyTorch.png", alt: "PyTorch" },
    { src: "/images/tech-stack/Keras.png", alt: "Keras" },
    { src: "/images/tech-stack/Pandas.png", alt: "Pandas" },
    { src: "/images/tech-stack/NumPy.png", alt: "NumPy" },
    { src: "/images/tech-stack/spaCy.png", alt: "spaCy" },
    { src: "/images/tech-stack/BERT.png", alt: "BERT" },
    { src: "/images/tech-stack/GPT.png", alt: "GPT" },
    { src: "/images/tech-stack/OpenCV.png", alt: "OpenCV" },
    { src: "/images/tech-stack/ResNet.png", alt: "ResNet" },
    { src: "/images/tech-stack/Midjourney.png", alt: "Midjourney" },
    { src: "/images/tech-stack/Pinecone.png", alt: "Pinecone" },
    { src: "/images/tech-stack/Matplotlib.png", alt: "Matplotlib" },
    { src: "/images/tech-stack/PowerBI.png", alt: "Power BI" },
    { src: "/images/tech-stack/Tableau.png", alt: "Tableau" },
    { src: "/images/tech-stack/PostgreSQL.png", alt: "PostgreSQL" },
    { src: "/images/tech-stack/MongoDB.png", alt: "MongoDB" },
    { src: "/images/tech-stack/AWS.png", alt: "AWS" },
    { src: "/images/tech-stack/MicrosoftAzure.png", alt: "Microsoft Azure" },
    { src: "/images/tech-stack/GoogleCloudPlatform.png", alt: "Google cloud platform" },
    { src: "/images/tech-stack/Docker.png", alt: "Docker" },
    { src: "/images/tech-stack/Kubernetes.png", alt: "Kubernetes" },
    { src: "/images/tech-stack/Git.png", alt: "Git" }
];

const AIServicesLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();
    
    const solutionsList = [
        {title: t(`${key}.categories.1.label`), description: t(`${key}.categories.1.description`), icon: '/images/icons/ml.svg'},
        {title: t(`${key}.categories.2.label`), description: t(`${key}.categories.2.description`), icon: '/images/icons/chatbot.svg'},
        {title: t(`${key}.categories.3.label`), description: t(`${key}.categories.3.description`), icon: '/images/icons/magnifying-glass.svg'},
        {title: t(`${key}.categories.4.label`), description: t(`${key}.categories.4.description`), icon: '/images/icons/megaphone.svg'},
        {title: t(`${key}.categories.5.label`), description: t(`${key}.categories.5.description`), icon: '/images/icons/analytics.svg'},
        {title: t(`${key}.categories.6.label`), description: t(`${key}.categories.6.description`), icon: '/images/icons/create-post.svg'}
    ];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [getQuote, setGetQuote] = useState(false);
        
    const getAQuote = useCallback(() => {
        // setGetQuote(true);

        window.open(companyData.contact.formLinks.quotation, "_blank");
    }, []);

    return (
        <>
            <NavigationLayout />

            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <DigitalServicesHero 
                        banner='/images/services/ai/aiBanner.png'
                        title={t(`${key}.title`)}
                        description={t(`${key}.description`)}
                        imageLgSize="60%"
                    />

                    <SolutionsView list={solutionsList}/>

                    <TechStackList list={techStackList}/>

                    <ProjectDetails list={projectsData.ai}/>

                    <Stack
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        width='100%'
                    >
                        <ButtonComponent 
                            label={t('navigation.quote')}
                            onClick={getAQuote}
                            sx={{
                                animation: 'bounceButton 1s infinite'
                            }}
                        />
                    </Stack>
                </Stack>
            </Box>

            <GetQuote open={getQuote} setOpen={setGetQuote}/>

            <FooterLayout />
        </>
    );
}

export default AIServicesLayout;